<template>
  <v-theme-provider root>
    <v-app id="app" v-hotkey="keymap">
      <v-app-bar :dark="darkmode" v-if="isLoggedin && Object.keys(this.gamedata).length > 0"
                 v-show="!overlay && !isRoute('logout') && !isRoute('no-permission') && !isRoute('game-not-started')"
                 flat app height="60px" class="headerBar theme-border"
                 elevation="4">
        <v-card id="header-left" flat tile class="d-flex align-center theme-background" height="100%"
                :style="{width: isRoute('report') ? buttonsWidth : '22%'}">
          <v-app-bar-nav-icon @click="showMenu = true" width="60" height="58" class="theme-title"/>

          <v-toolbar-items style="max-width: calc(100% - 60px);">
            <FullScreen />
            <Connection/>
          </v-toolbar-items>
        </v-card>

        <v-card flat tile class="d-flex align-center mid-header theme-background" height="100%"
                v-if="Object.keys(this.gamedata).length > 0">
          <TimeOut v-if="isRoute('report')" :team="!isMirrored ? teamA : teamB" :clockData="clockData"
                   :gamefinished="gameFinished" :gameData="gamedata" :hotkeys="hotkeysAllowed" :period="currentPeriod"
                   class="ml-4 mr-8"/>
          <v-spacer v-show="isRoute('report')"/>
          <Period
              :enabled="canSwitchPeriods"
              :items="periodItems"
              :currentPeriod="currentPeriod"
              @periodChanged="onPeriodChange"
              :style="{marginLeft: (isRoute('substitute') || isRoute('dmr')) ? 'calc(36% - 210px)' : '0'}"
          />
          <Clock ref="clock" :clockDisable="clockDisable || isRoute('dmr')"
                 :settingsDisable="settingsDisable || isRoute('dmr')"
                 :hotkeys="hotkeysAllowed" :period="currentPeriod" :gamefinished="gameFinished" :gamedata="gamedata"
                 v-if="Object.keys(this.gamedata).length > 0"/>
          <v-spacer v-show="isRoute('report')"/>
          <TimeOut v-if="isRoute('report')" :team="!isMirrored ? teamB : teamA" :clockData="clockData"
                   :gamefinished="gameFinished" :gameData="gamedata" :hotkeys="hotkeysAllowed" :period="currentPeriod"
                   class="mr-4 ml-8"/>
          <v-btn v-if="showDevTools" tile type="button" @click="disconnect">DC</v-btn>
          <v-btn v-if="showDevTools" tile type="button" @click="reconnect">RC</v-btn>
        </v-card>

        <v-card id="header-right"
                v-if="(isRoute('report') && this.gamedata.rule !== 'STRAND' && Object.keys(this.gamedata).length > 0) || isRoute('dmr')"
                tile flat
                class="d-flex justify-center align-center theme-background" height="100%"
                :style="{width: buttonsWidth}">
          <TeamName :team="teamA" :teamShortName="gamedata.team_a_shortname"
                    :teamName="gamedata.team_a_name"/>
          <TeamScore :team="teamA" :score="gamedata.team_a_score" teamId="teamA" :gamedata="gamedata"/>
          <span class="score-spacer ml-1 mr-1 theme-title"> - </span>
          <TeamScore :team="teamB" :score="gamedata.team_b_score" teamId="teamB" :gamedata="gamedata"/>
          <TeamName :team="teamB" :teamShortName="gamedata.team_b_shortname"
                    :teamName="gamedata.team_b_name"/>
        </v-card>

        <v-card v-if="isRoute('report') && Object.keys(this.gamedata).length > 0 && this.gamedata.rule === 'STRAND'"
                tile flat
                class="d-flex justify-center align-center theme-background" height="100%"
                :style="{width: buttonsWidth}">
          <v-container>
            <v-row no-gutters>
              <v-col style=" display: flex; justify-content: center; align-items: center;">
                <TeamName :team="teamA" :teamShortName="gamedata.team_a_shortname" :teamName="gamedata.team_a_name"/>
              </v-col>
              <v-col style=" display: flex; justify-content: center; align-items: center;">
                <TeamSetScores :gamedata="gamedata" :currentPeriod="currentPeriod"/>
              </v-col>
              <v-col style=" display: flex; justify-content: center; align-items: center;">
                <TeamName :team="teamB" :teamShortName="gamedata.team_b_shortname" :teamName="gamedata.team_b_name"/>
              </v-col>
            </v-row>
            <v-row no-gutters
                   style=" display: flex; justify-content: center; align-items: center; width: 100%; transform: scale(0.5); transform-origin: center center; margin-top: -25px; margin-bottom: -10px;">
              <TeamScores :gamedata="gamedata" :appBar="true" :currentPeriod="currentPeriod" :isMirrored="isMirrored"/>
            </v-row>
          </v-container>
        </v-card>
      </v-app-bar>

      <v-navigation-drawer v-if="isLoggedin && Object.keys(this.gamedata).length > 0"
                           v-show="!overlay && !isRoute('logout') && !isRoute('no-permission') && !isRoute('game-not-started')"
                           v-model="showMenu" absolute temporary :dark="darkmode">
        <Settings :darkmode="darkmode" :hotkeys="hotkeys" :gamedata="gamedata"/>

        <v-list v-if="!isRoute('dmr')">
          <v-list-item-group color="primary">
            <v-list-item @click="ShowFinishDialog" :disabled="(currentPeriod !== '13')">
              <span class="settings-label">Beküldés</span>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <v-list>
          <v-list-item-group color="primary">
            <v-list-item @click="exportOfflineData">
              <span class="settings-label">Adatok exportálása</span>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <v-list>
          <v-list-item-group color="primary">
            <v-list-item @click="logout">
              <span class="settings-label">Kilépés</span>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <v-list>
          <v-list-item>
            <small>{{ appVersion }}</small>
          </v-list-item>
        </v-list>

      </v-navigation-drawer>

      <v-content
          :class="isRoute('logout') || isRoute('no-permission') || isRoute('game-not-started') ? 'theme-default' : ''">
        <router-view
            v-if="!overlay || !isLoggedin || isRoute('logout') || isRoute('no-permission') || isRoute('game-not-started')"
            :canvasWidth="canvasWidth" :canvasHeight="canvasHeight" :buttonsWidth="buttonsWidth"
            :isLoggedin="isLoggedin" :ref="isRoute('report') ? 'reportScreen' : null"
            :dark="darkmode" :isMirrored="isMirrored" :hotkeys="hotkeysAllowed" :gamedata="gamedata"
            :gamefinished="gameFinished"
            :periodItems="periodItems" :period="currentPeriod" :substituteTimeline="substituteTimeline"
            :dmrTimelineProp="dmrTimeline" :dmrPlayers="dmrPlayers" :sortedList="sortedList"/>
        <v-overlay v-if="!isRoute('logout') && !isRoute('no-permission') && !isRoute('game-not-started')"
                   :value="overlay && isLoggedin" :dark="darkmode" :z-index="203" :opacity="0.9">
          <v-progress-circular indeterminate size="128"/>
        </v-overlay>
      </v-content>

      <SyncDialog/>

      <GameSyncDialog/>

      <GameFinishDialog/>

      <GameOverDialog/>

      <!-- JAVÍTÁS: új alkalmazás-verzió felajánlása. A service worker
           alapértelmezés szerint "waiting" állapotban áll, amíg az app összes
           füle be nem zárul - egy sima oldalfrissítés NEM aktiválja, ezért a
           kliensoldali javítások korábban nem jutottak el a felhasználókhoz
           (l. registerServiceWorker.js). Szándékosan NEM automatikus: a
           jegyzőkönyvvezető dönti el, mikor frissít, hogy mérkőzés közben ne
           cserélődjön ki a kód alatta. `timeout="-1"`: nem tűnik el magától. -->
      <v-snackbar v-model="swUpdateReady" :timeout="-1" bottom right :dark="darkmode" :z-index="300">
        Új verzió érhető el a digitális jegyzőkönyvből.
        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" :loading="swUpdating" @click="applyServiceWorkerUpdate">
            Frissítés
          </v-btn>
          <v-btn text v-bind="attrs" @click="swUpdateReady = false">
            Később
          </v-btn>
        </template>
      </v-snackbar>

    </v-app>
  </v-theme-provider>
</template>

<script>
import Bugsnag from "@bugsnag/js";

var debug = require('debug')('MKSZ:App');

// Plugins
//import router from '@/plugins/router';
import {hotkeys} from '@/plugins/hotkeys';

// Components
import Connection from '@/components/Connection'
import TimeOut from "@/components/TimeOut";
import Clock from "@/components/Clock";
import Period from "@/components/Period";
import Settings from "@/components/Settings";
import TeamName from "@/components/TeamName";
import TeamScore from "@/components/TeamScore";
import TeamScores from "@/components/strand/TeamScores.vue";
import TeamSetScores from "@/components/strand/TeamSetScores.vue";
import eventBus from '@/eventBus';

// Etc.
import CONSTANTS from "./constants";
import stopwatch from "./Stopwatch";

import store from "@/store";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import SyncDialog from "@/components/dialogs/SyncDialog.vue";
import GameSyncDialog from "@/components/dialogs/GameSyncDialog.vue";
import GameFinishDialog from "@/components/dialogs/GameFinishDialog.vue";
import {downloadMatchExport} from "@/utils/matchExport";
import GameOverDialog from "@/components/dialogs/GameOverDialog.vue";
import FullScreen from "@/components/FullScreen.vue";

import busListeners from "@/mixins/busListeners";

export default {
    mixins: [busListeners],
  name: 'App',
  components: {
    FullScreen,
    GameOverDialog,
    GameFinishDialog,
    GameSyncDialog,
    SyncDialog,
    Period,
    TimeOut,
    Connection,
    Clock,
    Settings,
    TeamName,
    TeamScore,
    TeamScores,
    TeamSetScores
  },
  beforeMount() {
    window.dbmanager.initdb('mksz').then((data) => {
      if (document.getElementById('pageloader'))
        document.getElementById('pageloader').remove();

      this.$store.dispatch('connection/initConnectionListeners');
    });
  },
  data() {
    let p = this.isPortrait();
    document.body.className = p ? "port" : "";
    let sizes = this.getSizes(document.body.scrollWidth, document.body.scrollHeight);

    return {
      // Service worker frissítés felajánlása (l. registerServiceWorker.js)
      swUpdateReady: false,      // látszik-e a "Frissítés" sáv
      swUpdating: false,         // a gomb megnyomása után, újratöltésig
      swRegistration: null,      // a várakozó service workert tartalmazó registration
      clockDisable: this.isRoute('substitute') || this.isRoute('dmr'),
      settingsDisable: this.isRoute('dmr'),
      canvasWidth: sizes.canvasWidth + 'px',
      canvasHeight: sizes.canvasHeight + 'px',
      buttonsWidth: sizes.buttonsWidth + 'px',
      portrait: p,
      currentSaveMethod: 'auto',
      clockData: Clock.data(),
      firstStart: true,
      teamScores: null,
      teamSetScores: null,
      reconnectLocked: false,
      hasConnectedOnce: false,
      syncTimeout: null, // JAVÍTÁS: Új data property a debounce-hoz
    };
  },
  created() {
    let self = this;

    // --- JAVÍTOTT RÉSZ: Kapcsolat változás figyelése ---
    // FONTOS: handleReconnect CSAK valódi újracsatlakozáskor ('ok') fusson,
    // NEM pedig minden egyes sikeres sync után ('okfromsync').
    // A 'syncDone' minden szinkronizált esemény után 'okfromsync'-ot emitál,
    // ami korábban feleslegesen újra és újra meghívta a handleReconnect-et.
    this.$busOn(CONSTANTS.EVENTS.CHANGE.CONNECTION, function (status) {

      // Csak 'ok' státuszra reagálunk (valódi socket reconnect),
      // 'okfromsync' = rutin sync, NEM kell handleReconnect
      if (status === 'ok') {

        if ((window.usertype === 'report' || window.usertype === 'dmr') && !self.reconnectLocked) {

          // Az első csatlakozásnál a loadDataFromDB már lefut,
          // csak az újracsatlakozásnál kell handleReconnect
          if (self.hasConnectedOnce) {
            console.log(`[App] Kapcsolat ÚJRA helyreállt (${window.usertype}). Szinkronizáció indítása...`);

            self.reconnectLocked = true;
            self.$store.dispatch('game/handleReconnect');

            setTimeout(() => {
              self.reconnectLocked = false;
            }, 2000);
          } else {
            self.hasConnectedOnce = true;
          }
        }
      }
    });

    // JAVÍTÁS: Periodikus "utó-szinkron" MINDHÁROM felületen (hálózati verseny
    // elleni védelem). Ha KÉT kliens (pl. CR és DMR) nagyjából egyszerre
    // reconnectel, előfordulhat, hogy az EGYIK reconnectkor lekérdezett "friss"
    // szerver-állapot valójában MÉG a MÁSIK kliens éppen csak akkor
    // feltöltődő módosítása ELŐTTI pillanatkép - a másik kliens offline
    // módosításának feltöltése egy tőlünk FÜGGETLEN, aszinkron folyamat,
    // aminek befejeződésére semmi sem garantál konkrét időt. Élő teszteléssel
    // ez a verseny szinte minden alkalommal reprodukálható volt két,
    // egymástól függetlenül kezelt kliens között - és enélkül a felület
    // mindaddig a régi adatot mutatta, amíg a felhasználó kézzel újra nem
    // csatlakoztatott, ami ingadozó hálózat mellett elfogadhatatlan.
    // JAVÍTÁS: eredetileg ez a védelem csak DMR-re volt bekötve - de a CR
    // felület ugyanígy lekésheti DMR időközbeni jóváhagyását/elutasítását,
    // ha épp CR reconnectje nyeri (illetve veszíti el) a versenyt DMR
    // feltöltésével szemben. A SUB felület biztonságos bevonását a
    // loadGameData saját, meglévő védelme biztosítja (l. game.js elején: futó
    // óránál SUB-on a függvény önmagát kihagyja, így itt nem okoz vibrálást).
    // Ezért amíg a kliens csatlakoztatva van, néhány másodpercenként
    // automatikusan, felhasználói beavatkozás nélkül újra lefuttatjuk ugyanazt
    // a "smart merge" letöltést, ami reconnectkor is fut - így egy elvesztett
    // verseny esetén is garantáltan, korlátos időn belül magától helyreáll a
    // felület, várakozás vagy kézi újracsatlakoztatás nélkül.
    if (window.usertype === 'dmr' || window.usertype === 'report' || window.usertype === 'sub') {
        self.periodicResyncInterval = setInterval(() => {
            if (window.vueio && window.vueio.connected) {
                // JAVÍTÁS (4515b - Bugsnag-logolás bővítése): mérjük a periodikus
                // "smart merge" resync futásidejét. Ez segít megerősíteni, hogy a
                // fentebbi duplikáció-eltávolítás ténylegesen csökkentette-e a
                // terhelést éles környezetben, és korán jelez egy jövőbeli,
                // visszatérő lassulást (pl. ha egy másik résznek nő meg a
                // futásideje a rögzített események számával) - anélkül, hogy
                // minden egyes ciklust logolnánk, csak a ténylegesen lassú
                // eseteket (2 másodperc felett).
                const resyncStartedAt = performance.now();
                self.$store.dispatch('game/loadGameData').then(() => {
                    const resyncDurationMs = Math.round(performance.now() - resyncStartedAt);
                    if (resyncDurationMs > 2000) {
                        const timelineCount = (self.$store.state.game.timelineData || []).length;
                        Bugsnag.notify('Slow periodic resync: ' + resyncDurationMs + 'ms', function (event) {
                            event.severity = 'warning';
                            event.context = 'Periodic resync (' + window.usertype + ')';
                            event.addMetadata('resync', {
                                durationMs: resyncDurationMs,
                                usertype: window.usertype,
                                timelineCount: timelineCount,
                                merkozesId: window.dbname
                            });
                        });
                    }
                    // JAVÍTÁS (lassulás, 4515b): a `game/loadGameData` már saját maga,
                    // a törzse VÉGÉN (game.js ~993-994. sor) MINDEN felhasználótípusra
                    // (report/dmr/sub) lefuttatja a `reCalculateScores`-t (pontosan
                    // ugyanezekkel a paraméterekkel: {totalGameTime: 0, sync: false})
                    // és a `recalculateDrafts`-ot is - mindkettő idempotens (nullától
                    // számol újra, csak felülíró mutációkat commit-ol, a `sync:false`
                    // miatt semmilyen mellékhatású DB-visszaírást nem végez). Az itteni,
                    // "report" ágra korlátozott, KÜLÖN hívás ezért 100%-ban felesleges
                    // duplikálás volt - minden 10 másodperces cikluson a CR felületen
                    // KÉTSZER futott le ugyanaz a két, a rögzített események számával
                    // arányosan lassuló újraszámolás, ami hozzájárult a mérkőzés
                    // előrehaladtával jelentkező lassuláshoz. A DMR-ágon lévő
                    // `dmr/initDmr` VALÓDI, egyedi hívás (ezt a loadGameData nem
                    // végzi el), az változatlan maradt.
                    if (window.usertype === 'dmr') {
                        self.$store.dispatch('dmr/initDmr');
                    }
                });
            }
        }, 10000);
    }

    // JAVÍTÁS: Debounced Sync Listener
    this.$busOn('DB_CHANGE_EVENT', () => {
        // Töröljük a korábbi időzítőt, ha volt
        if (self.syncTimeout) {
            clearTimeout(self.syncTimeout);
        }

        // Elindítunk egy újat. Ha 500ms-ig nem jön újabb 'DB_CHANGE_EVENT', akkor lefut a sync.
        self.syncTimeout = setTimeout(() => {
            console.log('[SYNC] Debounced sync triggered.');
            if (window.dbmanager && window.vueio.connected) {
                window.dbmanager.sync();
            }
        }, 500);
    });


    window.period = '1';
    window.stopwatch = stopwatch;
    window.addEventListener("resize", this.screenResize);

    // JAVÍTÁS (4514 - proaktív felszabadítás): amikor ez a lap elhagyásra
    // kerül (bezárás, frissítés, másik oldalra navigálás), azonnal jelezzük
    // a workernek, hogy zárja be a helyi IndexedDB kapcsolatát, ahelyett hogy
    // megvárnánk, amíg a böngésző magától felszámolja azt. Enélkül egy
    // másik, ugyanabban a böngészőben ÉPP EKKOR megnyitni próbált mérkőzés
    // (a "mksz" adatbázis MINDEN mérkőzés között KÖZÖS) feleslegesen
    // blokkolódhatna. A `pagehide` megbízhatóbb, mint a `beforeunload` (amit
    // a böngészők egyre inkább korlátoznak) - ez csak akkor segít, ha ez a
    // lap még ténylegesen fut a bezárás pillanatában; egy már alvó/
    // felfüggesztett háttér-lapnál ez a kód sem tud lefutni, az ellen a
    // LoginScreen.vue-beli türelmes újrapróbálkozás és a felhasználói
    // útmutatás védekezik.
    this._pagehideHandler = function () {
        if (window.dbmanager) {
            window.dbmanager.closeConnection();
        }
    };
    window.addEventListener("pagehide", this._pagehideHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.screenResize);
    if (this._pagehideHandler) {
        window.removeEventListener("pagehide", this._pagehideHandler);
    }
    if (this.periodicResyncInterval) {
        clearInterval(this.periodicResyncInterval);
    }
  },
  mounted() {
    let self = this;

    // Új alkalmazás-verzió elérhető (l. registerServiceWorker.js). Csak
    // megjelenítjük a felajánlást - a frissítés időzítése a felhasználóé.
    eventBus.$on(CONSTANTS.EVENTS.SW.UPDATED, (registration) => {
      self.swRegistration = registration;
      self.swUpdateReady = true;
    });

    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.SYNC, data => {
      debug("SOCKET SYNC RECEIVED:", data);
      if (data && data.type === 'periodchange') {

        if (self.isRoute('report')) {
          console.log('App.vue (CR): Socket period echo ignored to prevent double execution.');
          return;
        }

        console.log('App.vue (DMR/Sub): Socket period change accepted:', data.content);
        self.onPeriodChange(data.content);
      }
    });

    window.dbmanager.getConfig('darkmode').then((result) => {
      if (typeof result === "undefined" || result === null) {
        self.SET_DARKMODE(true);
        self.$vuetify.theme.dark = true;
        window.dbmanager.setConfig({name: 'darkmode', value: true});
      } else {

        self.SET_DARKMODE(result.value);
        self.$vuetify.theme.dark = result.value;
      }
    });

    window.dbmanager.getConfig('hotkeys').then((result) => {
      if (typeof result === "undefined" || result === null) {
        // JAVÍTÁS: touch-képes (mobil/tablet) eszközön a gyorsbillentyűk
        // eleve feleslegesek (virtuális billentyűzet van), ráadásul teljes
        // képernyős módban BÁRMILYEN billentyűleütés (nem csak szövegmezőbe
        // gépelés, hanem pl. a Space gyorsbillentyű is) kiváltja a Chrome
        // saját, beépített "úgy tűnik teljes képernyőn gépel" biztonsági
        // figyelmeztetését - ez elnyeli az első gombnyomást, ezért kellett
        // néha kétszer megnyomni pl. az óra indítását a SUB felületen.
        // Ez CSAK az alapértelmezett értéket változtatja meg ELSŐ
        // betöltéskor (ha még nincs mentett felhasználói preferencia) - ha
        // valaki korábban már kézzel beállította (be vagy ki), az a döntés
        // megmarad. A "Gyors gombok" kapcsoló a beállítások menüben
        // továbbra is elérhető, bárki visszakapcsolhatja.
        const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
        const defaultHotkeys = !isTouchDevice;
        self.SET_HOTKEYS(defaultHotkeys);
        window.dbmanager.setConfig({name: 'hotkeys', value: defaultHotkeys});
      } else {
        self.SET_HOTKEYS(result.value);
      }
    });

    window.dbmanager.getConfig('version').then((result) => {
      if (typeof result === "undefined" || (result && result.value !== window.appversion) || result === null) {
        window.dbmanager.setConfig({name: 'version', value: window.appversion});

        // JAVÍTÁS: itt korábban `self.basic` ment ki - az a Vuex `ui` modul
        // állapotából jött (`mapState('ui', ['basic'])`), ami `true`-ra volt
        // inicializálva, és amit a kódbázisban SEMMI nem írt át (egyetlen
        // mutáció sem nyúlt hozzá). Vagyis ez az ág FELTÉTEL NÉLKÜL
        // `BASICMODECHANGED: true`-t sugárzott szét - az ActionBar, a Court és
        // az összes Action* komponens erre kapcsol egyszerűsített nézetre.
        //
        // Mikor fut: ha a tárolt `version` config eltér a mostani
        // `appversion`-től VAGY még egyáltalán nincs eltárolva. Tehát
        // MINDEN verziófrissítés utáni ELSŐ betöltéskor, és minden új
        // eszközön/böngészőprofilban (pl. inkognitó) - pont azokban a
        // helyzetekben, amikor a bíró amúgy is bizonytalan.
        //
        // A Settings.vue NEM figyeli a BASICMODECHANGED-et, ezért a
        // "Egyszerűsített felület" kapcsoló ilyenkor NEM követte az
        // eseményt: a felület egyszerűsítettre váltott, a kapcsoló viszont
        // továbbra is a (helyes) tárolt értéket mutatta. Ez a szétcsúszás
        // nem hagy nyomot a mérkőzés adataiban, mert semmilyen rekord nem
        // íródik tőle.
        //
        // Most a ténylegesen eltárolt értéket sugározzuk szét (ha nincs
        // eltárolva: bővített), így ez az ág csak szinkronba hoz, nem vált át.
        window.dbmanager.getConfig('basic').then((basicConfig) => {
          const currentBasic = (basicConfig !== undefined && basicConfig !== null && typeof basicConfig.value !== "undefined")
              ? basicConfig.value
              : false;
          eventBus.$emit(CONSTANTS.EVENTS.BASICMODECHANGED, currentBasic);
        });
      }
    });

    self.$watch("$refs.clock.pause", function (isPaused) {
      self.clockData.pause = isPaused;
    });

    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.RESTOREDONE, () => {
      debug("matchrestoredone");
      self._restorePromises = self._restorePromises || [];
      Promise.all(self._restorePromises).then(() => {
          self._restorePromises = [];
          self.loadDataFromDB();
      }).catch(err => {
          console.error("Error during RESTORE writes:", err);
          self._restorePromises = [];
          self.loadDataFromDB();
      });
    });

    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.RESTORE, data => {
      debug("RESTORE: ", data);
      self._restorePromises = self._restorePromises || [];
      if (typeof data !== 'undefined' && typeof data.UUID !== 'undefined') {
        data.synced = true;
        let p = window.dbmanager.update(data, true);
        self._restorePromises.push(p);
      } else {
        debug(data);
      }
    });

    this.$busOn(CONSTANTS.EVENTS.SET.GAMEDATA, function (data) {
      self.SET_GAMEDATA(data);
    });

    this.$busOn('GAMESYNCDIALOG_CLOSE', function () {
      self.SET_GAMESYNCDIALOG(false);
    });

    this.$busOn(CONSTANTS.EVENTS.TEAMUPDATE, function (data) {
      let playerEntryScreen = self.isRoute('report') ? 'report' : 'substitute';

      self.$store.dispatch('game/addPlayerFromEntry', {
        team: data.team,
        player: data.player,
        playerEntryScreen: playerEntryScreen
      });
    });

    this.$busOn(CONSTANTS.EVENTS.MIRROR, function (value) {
      self.SET_ISMIRRORED(value);
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.DIRECTION, function (direction) {
      self.SET_ATTACKING_DIRECTION(direction);
      // JAVÍTÁS: Automatikus kapus ellenőrzés irányváltáskor
      self.$nextTick(() => {
        self.checkStrandGoalkeeper();
      });
    });

    this.$busOn(CONSTANTS.EVENTS.CLOCK.LOAD, function (value) {
      self.SET_TICK_IN_PROGRESS(value);
    });

    this.$busOn(CONSTANTS.EVENTS.PERIOD.SET.ITEMS, (value) => {
      self.SET_PERIOD_ITEMS(value);
    });

    this.$busOn(CONSTANTS.EVENTS.LOGIN.CHANGE, (value) => {
      self.SET_LOGIN_STATUS(value);

      if (value) {
        window.vueio.on("notloggedin", () => {
          Bugsnag.notify("Not Logged In", function (ev) {
            ev.severity = 'warning';
            ev.context = 'Not Logged in';
            let cookies = {};
            let helper = document.cookie.split("; ");
            for (const key in helper) {
              let tmp = helper[key].split("=");
              cookies[tmp[0]] = tmp[1];
            }

            ev.addMetadata('cookie_data', cookies);
          });
          if (typeof window.usertype !== 'undefined') {
            window.onbeforeunload = null;

            if (self.$route.path !== 'no-permission') {
              self.$router.replace('no-permission').catch(() => {
              });
            }
          }
        });
        window.dbmanager.sync();
        if (window.roomsize > 0) {
          window.dbmanager.getSyncableCount().then((data) => {
            self.SET_SYNCABLE_COUNT(data);
            if (self.syncablecount < 2) {
              window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.MATCHDATA);
              eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, true);
            } else {
              self.loadDataFromDB();
              self.SET_SYNCDIALOG(true);
            }

          });
        } else {
          self.loadDataFromDB();
        }

        window.setTimeout(() => {
          let images = [
            '/icons/A_dark.svg',
            '/icons/A_light.svg',
            '/icons/empty_gate.svg',
            '/icons/gate_dark.svg',
            '/icons/gate_empty.svg',
            '/icons/gate_fill.svg',
            '/icons/gate_light.svg',
            '/icons/gate_mini.svg',
            '/icons/M_dark.svg',
            '/icons/M_light.svg',

            '/court/dark/left/BA1.svg',
            '/court/dark/left/BA2.svg',
            '/court/dark/left/BA3.svg',
            '/court/dark/left/background.svg',
            '/court/dark/left/BT1.svg',
            '/court/dark/left/BT2.svg',
            '/court/dark/left/BT3.svg',
            '/court/dark/left/FB.svg',
            '/court/dark/left/K.svg',
            '/court/dark/left/lines.svg',
            '/court/dark/left/slice1.svg',
            '/court/dark/left/slice2.svg',
            '/court/dark/left/slice3.svg',
            '/court/dark/left/slice4.svg',
            '/court/dark/left/slice5.svg',
            '/court/dark/left/slice6.svg',
            '/court/dark/left/slice7.svg',
            '/court/dark/left/slice8.svg',
            '/court/dark/left/ST.svg',

            '/court/dark/right/BA1.svg',
            '/court/dark/right/BA2.svg',
            '/court/dark/right/BA3.svg',
            '/court/dark/right/background.svg',
            '/court/dark/right/BT1.svg',
            '/court/dark/right/BT2.svg',
            '/court/dark/right/BT3.svg',
            '/court/dark/right/FB.svg',
            '/court/dark/right/K.svg',
            '/court/dark/right/lines.svg',
            '/court/dark/right/slice1.svg',
            '/court/dark/right/slice2.svg',
            '/court/dark/right/slice3.svg',
            '/court/dark/right/slice4.svg',
            '/court/dark/right/slice5.svg',
            '/court/dark/right/slice6.svg',
            '/court/dark/right/slice7.svg',
            '/court/dark/right/slice8.svg',
            '/court/dark/right/ST.svg',

            '/court/light/left/BA1.svg',
            '/court/light/left/BA2.svg',
            '/court/light/left/BA3.svg',
            '/court/light/left/background.svg',
            '/court/light/left/BT1.svg',
            '/court/light/left/BT2.svg',
            '/court/light/left/BT3.svg',
            '/court/light/left/FB.svg',
            '/court/light/left/K.svg',
            '/court/light/left/lines.svg',
            '/court/light/left/slice1.svg',
            '/court/light/left/slice2.svg',
            '/court/light/left/slice3.svg',
            '/court/light/left/slice4.svg',
            '/court/light/left/slice5.svg',
            '/court/light/left/slice6.svg',
            '/court/light/left/slice7.svg',
            '/court/light/left/slice8.svg',
            '/court/light/left/ST.svg',

            '/court/light/right/BA1.svg',
            '/court/light/right/BA2.svg',
            '/court/light/right/BA3.svg',
            '/court/light/right/background.svg',
            '/court/light/right/BT1.svg',
            '/court/light/right/BT2.svg',
            '/court/light/right/BT3.svg',
            '/court/light/right/FB.svg',
            '/court/light/right/K.svg',
            '/court/light/right/lines.svg',
            '/court/light/right/slice1.svg',
            '/court/light/right/slice2.svg',
            '/court/light/right/slice3.svg',
            '/court/light/right/slice4.svg',
            '/court/light/right/slice5.svg',
            '/court/light/right/slice6.svg',
            '/court/light/right/slice7.svg',
            '/court/light/right/slice8.svg',
            '/court/light/right/ST.svg',
          ];

          images.forEach(image => {
            new Image().src = image;
          });
        }, 3000);
      }
    });

    /**
     * Sárgalapok adásának globális kezelése
     *
     * @param  object event Object ami tartalmazza a játékost
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.CARDS.GIVE.YELLOW, (event) => {
      debug('Event elkapva: %csárgalap%c adás: %o', 'color: #FDD835', 'color: unset', event);
      store.dispatch('game/giveYellowCard', event.player);
    });

    /**
     * Sárgalapok törlésének globális kezelése
     *
     * @param  object event Object ami tartalmazza a játékost
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.CARDS.TAKE.YELLOW, (event) => {
      debug('Event elkapva: %csárgalap%c törlés: %o', 'color: #FDD835', 'color: unset', event);
      store.dispatch('game/removeYellowCard', event.player);
    });

    /**
     * Piroslapok adásának globális kezelése
     *
     * Itt nincs jelentősége annak, hogy rendszer adta-e
     *
     * @param  object event Object ami tartalmazza a játékost, illetve hogy rendszer, vagy kezelő adta-e
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.CARDS.GIVE.RED, (event) => {
      debug('Event elkapva: %cpiroslap%c adás: %o', 'color: #D32F2F', 'color: unset', event);
    });

    /**
     * Kéklapok adásának globális kezelése
     *
     * @param  object event Object ami tartalmazza a játékost
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.CARDS.GIVE.BLUE, (event) => {
      debug('Event elkapva: %ckéklap%c adás: %o', 'color: #1E88E5', 'color: unset', event);
    });

    /**
     * Kiállítás adásának globális kezelése
     *
     * @param  object event Object ami tartalmazza a játékost
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.PENALTIES.GIVE, (event) => {
      debug('Event elkapva: %ckiállítás%c adás: %o', 'color: #D81B60', 'color: unset', event);
      if (!event.penalty.auto && ['staffA', 'staffB'].includes(event.capturedEvent.params.selectedTeamId)) {
        self.officialPenaltiesGiven[event.capturedEvent.params.selectedTeamId.substr(-1)] = true;
      }

      store.dispatch('game/givePenalty', {
        player: event.player,
        penalty: event.penalty,
        count: event.penalty.count || 1,
        event: event.capturedEvent // Kell a piros lap generáláshoz
      });
    });

    /**
     * Kiállítás törlésének globális kezelése
     *
     * @param  object event Object ami tartalmazza a játékost
     * @return null
     */
    this.$busOn(CONSTANTS.ACTIONS.PENALTIES.TAKE, (event) => {
      debug('Event elkapva: %ckiállítás%c törlés: %o', 'color: #D81B60', 'color: unset', event);
      if (['staffA', 'staffB'].includes(event.params.selectedTeamId)) {
        self.officialPenaltiesGiven[event.params.selectedTeamId.substr(-1)] = false;
      }
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.DARKMODE, function (darkMode) {
      self.SET_DARKMODE(darkMode);
      self.$vuetify.theme.dark = darkMode;
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.HOTKEYS, function (hotkeys) {
      self.SET_HOTKEYS(hotkeys);
    });

    this.$busOn(CONSTANTS.EVENTS.CLOCK.DISABLE, function (value) {
      self.clockDisable = value;
    });

    this.$busOn(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, function (value) {
      self.settingsDisable = value;
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.GAMEDATA, function (name, value) {
      if (name === 'team_a_actual_goalkeeper') {
        store.dispatch('game/updateGoalkeeper', {
          team: 'A',
          playerId: (value && value.id) ? value.id : null
        });
      }
      else if (name === 'team_b_actual_goalkeeper') {
        store.dispatch('game/updateGoalkeeper', {
          team: 'B',
          playerId: (value && value.id) ? value.id : null
        });
      }
      else {
      }
      self.gamedata[name] = value;
      window.gamedata[name] = value;
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.GAMEDATALOADED, function () {
      store.dispatch('game/reCalculateScores', {totalGameTime: 0, sync: false});
    });

    this.$busOn(CONSTANTS.EVENTS.CHANGE.DIALOG, function (value) {
      self.SET_OPENEDDIALOG(value);
    });

    this.$busOn(CONSTANTS.EVENTS.RECALCULATE, function (record) {
      let goalActions = CONSTANTS.ACTIONS.RECALCULATE_ACTIONS;
      if (goalActions.includes(record.action) ||
          (record.modifiedRecord && goalActions.includes(record.modifiedRecord.action))
      ) {
        store.dispatch('game/reCalculateScores', {totalGameTime: record.totalGameTime, sync: true});
      }
    });

    this.$busOn(CONSTANTS.EVENTS.PERIOD.CHANGED.CLOCK, function (value) {
      self.$store.dispatch('game/recalculateDrafts');
      self.$store.dispatch('game/recalculateRejecteds');
      self.SET_GAMEOVERDIALOG(value == 13);
    });

    //szétlövés engedélyezése/tiltása
    this.$busOn(CONSTANTS.EVENTS.PERIOD.ENABLE.SHOOTOUT, function (enable) {
      if (self.gamedata && self.gamedata.rule === 'STRAND' && self.periodItems) {
        let index = self.periodItems.findIndex(item => parseInt(item.value) === 12);
        if (typeof index !== 'undefined' && index > -1 && self.periodItems[index]) {
          self.periodItems[index].disabled = !enable;
        }
      }
    });

    // félidő váltás, leginkább childrentől jövő (DMRSreen) esemény
    this.$busOn(CONSTANTS.EVENTS.PERIOD.CHANGE, function (value) {
      self.onPeriodChange(value);
    });
  },
  methods: {
    /**
     * A "Frissítés" gomb kezelője: aktiválja a várakozó service workert, majd
     * újratölt. A sorrend fontos - ha csak `location.reload()`-ot hívnánk, a
     * RÉGI service worker szolgálná ki az oldalt, és semmi nem változna.
     *
     * A `{type: 'SKIP_WAITING'}` üzenetet a Workbox által generált service
     * worker figyeli (workbox-build 6.6.0 sw-template: `skipWaiting` opció
     * hiányában bekerül a `self.addEventListener('message', ...)` ág, ami erre
     * az üzenetre hívja a `self.skipWaiting()`-et - ellenőrizve a telepített
     * csomagban). Utána a böngésző `controllerchange` eseménnyel jelzi, hogy az
     * új worker átvette az irányítást - CSAK EKKOR szabad újratölteni.
     */
    applyServiceWorkerUpdate() {
      const self = this;
      const reg = this.swRegistration;
      this.swUpdating = true;

      const ujratolt = function () {
        if (self._swReloading) return;    // a controllerchange néha kétszer is jön
        self._swReloading = true;
        window.location.reload();
      };

      // Ha időközben eltűnt a várakozó worker (pl. egy másik fül már aktiválta),
      // a sima újratöltés már a friss verziót adja.
      if (!reg || !reg.waiting || !('serviceWorker' in navigator)) {
        ujratolt();
        return;
      }

      if (!this._swReloadBound) {
        this._swReloadBound = true;
        navigator.serviceWorker.addEventListener('controllerchange', ujratolt);
      }

      // Biztonsági háló: ha a controllerchange valamiért nem érkezne meg, ne
      // ragadjon a felhasználó egy pörgő gombon.
      setTimeout(ujratolt, 5000);

      reg.waiting.postMessage({type: 'SKIP_WAITING'});
    },

    ...mapActions('game', ['loadGameData']),
    ...mapMutations('game', ['SET_ATTACKING_DIRECTION', 'SET_PERIOD_ITEMS', 'SET_PERIOD', 'SET_SYNCABLE_COUNT', 'SET_GAME_FINISHED', 'SET_GAMEDATA']),
    ...mapMutations('ui', ['SET_OVERLAY', 'SET_DARKMODE', 'SET_HOTKEYS', 'SET_SHOW_MENU', 'TOGGLE_MENU', 'SET_LOGIN_STATUS', 'SET_ISMIRRORED', 'SET_TICK_IN_PROGRESS', 'SET_GAMESYNCDIALOG', 'SET_SYNCDIALOG', 'SET_GAMEFINISHDIALOG', 'SET_OPENEDDIALOG', 'SET_GAMEOVERDIALOG', 'SET_STRAND_GOALKEEPER_DIALOG']),
    ...mapMutations('connection', ['SET_CONNECTED_ONCE', 'SET_CONNECTION_STATUS', 'SET_STATUS', 'SET_SYNCING', 'SET_RESTORE_DIALOG']),


    // Az adatbázis exportáló metódus. A tényleges munka a közös
    // `src/utils/matchExport.js`-ben van - korábban itt és a
    // GameFinishDialog.vue-ban két, egymástól függetlenül karbantartott,
    // majdnem azonos másolat élt, mindkettő fixen a régi "mksz" adatbázist
    // nyitotta meg közvetlenül.
    async exportOfflineData() {
      await downloadMatchExport({notify: true});
    },

    // JAVÍTÁS: Robust kapus ellenőrzés (kezeli az .id és .value hiányát is)
    checkStrandGoalkeeper() {
      if (this.gamedata && this.gamedata.rule === 'STRAND') {
        const teamA = this.teamA; // Store-ból
        const teamB = this.teamB; // Store-ból

        // 1. Ellenőrzés a Store-ban (elsődleges)
        const hasGkStore = (gk) => gk && (gk.id || gk.value);

        // 2. Fallback ellenőrzés közvetlenül a gamedata-ból
        // Ez megvédi az oldalt attól, hogy felugorjon az ablak, ha a Store épp szinkronizálás alatt áll
        const hasGkInGamedata = (gkData) => {
          if (!gkData) return false;
          let val = gkData.id || gkData.value;
          // Ha csak egy string/szám az ID (nem objektum)
          if (!val && typeof gkData !== 'object') val = gkData;
          return !!val;
        };

        if (teamA.isAttacking) {
          // Ha 'A' támad -> 'B' védekezik -> 'B' kapus kell
          // Csak akkor dobjuk fel, ha SEM a Store-ban, SEM a nyers adatban nincs kapus
          if (!hasGkStore(teamB.goalkeeper) && !hasGkInGamedata(this.gamedata.team_b_actual_goalkeeper)) {
            this.SET_STRAND_GOALKEEPER_DIALOG(true);
          }
        } else if (teamB.isAttacking) {
          // Ha 'B' támad -> 'A' védekezik -> 'A' kapus kell
          if (!hasGkStore(teamA.goalkeeper) && !hasGkInGamedata(this.gamedata.team_a_actual_goalkeeper)) {
            this.SET_STRAND_GOALKEEPER_DIALOG(true);
          }
        }
      }
    },

    disconnect() {
      window.vueio.disconnect();
    },
    reconnect() {
      window.vueio.connect();
    },
    async loadDataFromDB() {
      let self = this;

      const result = await this.loadGameData();

      if (result) {
        if (self.gamedata && self.gamedata.rule === 'STRAND') {
          const syncPromises = [];
          const syncGk = (team, gkData) => {
            if (!gkData) return;
            let pId = gkData.id || gkData.value;
            if (!pId && typeof gkData !== 'object') {
              pId = gkData;
            }
            if (pId) {
              syncPromises.push(self.$store.dispatch('game/updateGoalkeeper', {
                team: team,
                playerId: pId
              }));
            }
          };
          syncGk('A', self.gamedata.team_a_actual_goalkeeper);
          syncGk('B', self.gamedata.team_b_actual_goalkeeper);
          if (syncPromises.length > 0) {
            await Promise.all(syncPromises);
          }
        }

        if (typeof self.gamedata !== "undefined") {
          if ((typeof self.gamedata.team_a_actual_goalkeeper.id !== 'undefined' || typeof self.gamedata.team_b_actual_goalkeeper.id !== 'undefined')) {
            eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIALOG, false);
          }
        }

        self.SET_OVERLAY(false);

        self.$nextTick(function () {
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.GAMEDATALOADED);
          if (!self.isRoute('substitute')) {
            eventBus.$emit(CONSTANTS.EVENTS.PERIOD.CHANGED.SUBSTITUTE, self.currentPeriod);
          }

          // --- JAVÍTÁS: KÉNYSZERÍTETT IRÁNY BEÁLLÍTÁS ---

          // 1. Lekérjük a Store-ból az állapotot (Amit a game.js már beállított)
          let storeDirection = self.$store.state.game.teamA.isAttacking ? 'left' : 'right';
          //console.log(`App.vue: Betöltés utáni irány (Store): ${storeDirection}`);

          // 2. Azonnal beállítjuk
          eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIRECTION, storeDirection);

          // 3. BIZTONSÁGI FRISSÍTÉS: Egy kis késleltetéssel újra ráküldjük,
          // hogy felülírjuk az esetleges ReportScreen/UI alaphelyzetbe állást.
          setTimeout(() => {
            // Újra kiolvassuk, hátha változott közben, de alapvetően a game.js döntése a mérvadó
            let finalDirection = self.$store.state.game.teamA.isAttacking ? 'left' : 'right';
            //console.log(`App.vue: Irány véglegesítése (Delayed): ${finalDirection}`);
            eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIRECTION, finalDirection);

            // Kapus ellenőrzés csak ezután
            self.checkStrandGoalkeeper();

            // --- JAVÍTÁS: UI FRISSÍTÉSE ADATBÁZIS TÖLTÉS UTÁN ---
            // Amikor a RESTOREDONE miatt újra betöltjük az IndexedDB-ből az adatokat,
            // frissíteni kell a képernyő-specifikus listákat (DMR és CR) is, hogy megjelenjenek
            // az offline mulasztott események.
            const urlParams = new URLSearchParams(window.location.search);
            if (window.usertype === 'report' || urlParams.get('felulet') === 'JEGYZOKONYV') {
                self.$store.dispatch('game/reCalculateScores', { totalGameTime: 0, sync: false });
                self.$store.dispatch('game/recalculateDrafts');
            } else if (window.usertype === 'dmr' || urlParams.get('felulet') === 'dmr') {
                self.$store.dispatch('dmr/initDmr');
            }
            // ----------------------------------------------------
          }, 200);

          // ----------------------------------------------
        });
      } else {
        self.SET_OVERLAY(false);
      }
    },
    toggleSidebar() {
      this.TOGGLE_MENU();
    },
    isRoute(url) {
      return this.$route.meta.header === url;
    },
    logout() {

      this.SET_SHOW_MENU(false);
      this.SET_OVERLAY(true);
      this.SET_GAMESYNCDIALOG(false);
      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.STOP);
      window.logoutWithoutClean();
    },
    screenResize: function () {
      let self = this;
      let _p = self.isPortrait();
      let route = self.$route.meta.header;

      document.body.className = _p ? "port" : "";

      if (_p !== self.portrait && route === 'report') {
        if (screen.width < 769 || screen.height < 769) {
          location.reload();
        }
      } else {
        if (['min', 'logout', 'no-permission', 'game-not-started'].includes(route)) {
          let sizes = self.getSizes(document.body.scrollWidth, document.body.scrollHeight);

          self.portrait = _p;
          self.canvasWidth = sizes.canvasWidth + 'px';
          self.canvasHeight = sizes.canvasHeight + 'px';
          self.buttonsWidth = sizes.buttonsWidth + 'px';
        }
      }
    },
    getSizes(w, h) {
      let tmp;

      if (w < h) {
        tmp = w;
        w = h;
        h = tmp;
      }

      let canvasHeight = h - 289;
      let canvasWidth = (454 / 503) * canvasHeight;
      let buttonsWidth = (w - canvasWidth - 16) / 3;

      return {
        canvasHeight,
        canvasWidth,
        buttonsWidth,
      };
    },
    isPortrait() {
      return window.innerHeight > window.innerWidth;
    },
    ShowFinishDialog() {
      this.$store.dispatch('game/recalculateDrafts');
      this.$store.dispatch('game/recalculateRejecteds');
      this.SET_GAMEFINISHDIALOG(true);
      this.SET_SHOW_MENU(false);
    },

    onPeriodChange: function (newValue) {
      let self = this;

      if (self.isRoute('substitute')) {
        console.log('App.vue (Sub): Local period view change ->', newValue);
        this.$store.commit('game/SET_PERIOD', newValue);
        eventBus.$emit(CONSTANTS.EVENTS.PERIOD.CHANGED.SUBSTITUTE, newValue);
        self.SET_GAMEOVERDIALOG(newValue == 13);
        return;
      }

      // JAVÍTÁS: az onPeriodChange NEM CSAK valódi periódusváltáskor fut le, hanem
      // MINDEN reconnect/resync (LASTTIMELOAD) alkalmával is - a Period.vue ilyenkor
      // a jelenlegi (változatlan) periódust "jelenti be újra". Ezért ELŐBB el kell
      // menteni a RÉGI periódust, mielőtt a dispatch felülírná.
      const wasGenuinePeriodChange = String(self.currentPeriod) !== String(newValue);

      this.$store.dispatch('game/changePeriod', newValue);

      // JAVÍTÁS: a CR oldalon a Period.vue setPeriod()-ja mindig meghívja a
      // window.stopwatch.setClockToPeriod()-ot (nullázza a periódushoz relatív
      // stopper-időt), amikor a jegyzőkönyvvezető átvált egy periódusra. A DMR (és
      // bármi más, ami NEM a CR-en helyben, hanem a socketen keresztül kapja meg a
      // periódusváltást, ld. a SYNC 'periodchange' figyelőt lejjebb) viszont eddig
      // sosem nullázta a saját stopperét - így a régi félidő relatív ideje benne
      // ragadt, és rááadódott az új periódus abszolút kezdőidejére. Ez okozta, hogy
      // pl. a mérkőzés manuális lezárásakor a DMR 90:00-t mutatott CR 60:00-ja
      // helyett (a 2. félidő relatív ideje duplán számított bele).
      //
      // JAVÍTÁS #2: ezt a nullázást KIZÁRÓLAG valódi periódusváltáskor szabad
      // elvégezni! Az onPeriodChange ugyanis a LASTTIMELOAD-on (reconnect/offline
      // resync) keresztül IS lefut a Period.vue-n át, akkor is, ha a periódus nem
      // változott, csak "újra be lett jelentve" ugyanaz az érték. Enélkül a
      // feltétel nélküli nullázás minden reconnectnél elvitte a stopper addig
      // eltelt idejét vissza a félidő elejére - függetlenül attól, hogy a
      // Clock.vue LASTTIMELOAD-kezelője helyesen próbálta-e visszaállítani, mert
      // ez a reset AZUTÁN futott le.
      if (wasGenuinePeriodChange) {
        window.stopwatch.setClockToPeriod();
      }

      let periodIndex = self.gamedata.periods.findIndex(item => item.value === newValue);
      periodIndex = (periodIndex !== -1 && typeof periodIndex !== 'undefined') ? periodIndex : null;

      if (typeof self.gamedata.periods[periodIndex] !== 'undefined' && ['zero', 'extendedzero'].includes(self.gamedata.periods[periodIndex].type)) {
        if (self.gamedata.rule === 'STRAND') {
          self.$nextTick(() => {
            eventBus.$emit(CONSTANTS.EVENTS.PERIOD.CHANGED.SELECTEDPERIOD, newValue);
          });
        }

        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.DISABLE, true);
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, true);
      } else {
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.DISABLE, false);
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, false);
        eventBus.$emit(CONSTANTS.EVENTS.PERIOD.CHANGED.SELECTEDPERIOD, newValue);
      }

      if (self.currentPeriod === "13") {
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.DISABLE, true);
      }
    },
  },
  watch: {
    gamedata: {
      handler: function () {
        this.$store.dispatch('game/updateSortedTimeline');
      },
      deep: true
    },
    // JAVÍTÁS: Visszatettem az irányváltás figyelését
    'teamA.isAttacking': function (newValue, oldValue) {
      // JAVÍTÁS: Ha az overlay (töltőképernyő) még aktív, ne csináljon semmit!
      // Ilyenkor még folyik az adatok betöltése/szinkronizálása.
      if (this.overlay) return;

      if (newValue !== oldValue) {
        this.$nextTick(() => {
          this.checkStrandGoalkeeper();
        });
      }
    }
  },
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION;
    },
    // 'basic' szándékosan NINCS itt: a Vuex ui modulban soha nem volt
    // karbantartva (l. a fenti getConfig('version') ág kommentjét), az
    // egyetlen felhasználója ez a komponens volt, és az is tévesen.
    ...mapState('ui', ['isMirrored', 'darkmode', 'isLoggedin', 'tickInProgress', 'overlay', 'hotkeys', 'hotkeysEnabled', 'activeDialog', 'GameSyncDialog', 'gameOverDialog', 'syncDialog', 'openedDialog']),
    ...mapState('game', ['gamedata', 'timelineData', 'dmrTimeline', 'dmrPlayers', 'substituteTimeline', 'currentPeriod', 'sortedList', 'periodItems', 'teamA', 'teamB', 'yellows', 'officialPenaltiesGiven', 'gameFinished', 'draftCount', 'rejectedCount', 'syncablecount']),
    ...mapState('connection', ['status', 'wasConnectedOnce', 'showRestoreDialog', 'isSyncing', 'currentConnectionStatus', 'possibleConnectionStatuses']),
    ...mapGetters('connection', ['showDevTools']),
    showMenu: {
      get() {
        return this.$store.state.ui.showMenu;
      },
      set(value) {
        this.$store.commit('ui/SET_SHOW_MENU', value);
      }
    },
    theme: function () {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    hotkeysAllowed: function () {
      let self = this;
      return self.hotkeys && !self.openedDialog && (self.isRoute('report') || self.isRoute('substitute'));
    },
    canSwitchPeriods: function () {
      let self = this;
      return self.isRoute('report') || self.isRoute('substitute');
    },
    keymap: function () {
      let self = this;

      // JAVÍTÁS: Ha a hotkey-k nincsenek engedélyezve, üres objektumot adunk vissza.
      // Így nem kerül be a hibás '' (üres string) vagy érvénytelen handler a map-be.
      if (!self.hotkeysAllowed) {
        return {};
      }

      return {
        // JAVÍTÁS: Objektumként adjuk át a 'keydown' eseményre a függvényt.
        // Ez megoldja a "h[t.type] is not a function" hibát.
        [hotkeys['sidebar']]: {
          keydown: this.toggleSidebar
        },
      }
    },
  }
}
</script>

<style>
/* CSS marad változatlan */
@font-face {
  font-family: TickingTimebombBB;
  src: url('~@/assets/TickingTimebombBB.otf') format("opentype");
}

html {
  overflow: auto !important;
}

body {
  overflow: hidden;
  position: absolute;
  left: 0;
  padding-top: env(safe-area-inset-top);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
}

body:not(.port) {
  width: 100vw;
  height: 100vh;
  top: 0;
}

body.port {
  width: 100vh;
  height: 100vw;
  transform: rotate(-90deg);
  transform-origin: left top;
  top: 100vh;
}

#app {
  width: 100%;
  height: 100%;
}

main {
  height: calc(100% - 60px);
}

.width-100 {
  width: 100%;
}

.dialog-container {
  max-height: 0 !important;
}

.v-application--wrap {
  min-height: 100% !important;
  height: 100% !important;
}

.v-app-bar__nav-icon {
  border-radius: 0 !important;
}

header.headerBar {
  border-style: solid;
  border-top-width: 0;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom-width: 2px;
}

header.headerBar .v-toolbar__content {
  padding: 0;
  height: 58px !important;
}

.mid-header {
  flex-basis: auto;
  flex-shrink: 1;
  flex-grow: 1;
}

.score-spacer {
  font-family: TickingTimebombBB;
  font-size: 33px;
  font-style: normal;
  color: #000000;
}

@media only screen and (max-width: 1024px) {
  @viewport {
    width: 1024px;
  }
}

@media only screen and (max-height: 768px) {
  @viewport {
    height: 768px;
  }
}

.v-card--link:focus:before {
  opacity: 0 !important;
}

.v-btn-toggle > .v-btn.v-btn {
  opacity: 1 !important;
}

.overPanel {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  overflow: hidden;
}

.theme--light.theme-default, .theme--light .theme-default {
  background-color: #ffffff !important;
}

.theme--light.theme-red-background, .theme--light .theme-red-background {
  background-color: #F73051 !important;
}

.theme--light.theme-green-background, .theme--light .theme-green-background {
  background-color: #4caf50 !important;
}

.theme--light.theme-red, .theme--light .theme-red {
  color: #F73051 !important;
}

.theme--light.theme-green, .theme--light .theme-green {
  color: #4caf50 !important;
}

.theme--light.theme-border-inverse, .theme--light .theme-border-inverse {
  border-color: #2d303e !important;
}

.theme--light.theme-red-border, .theme--light .theme-red-border {
  border-color: #F73051 !important;
}

.theme--light.theme-green-border, .theme--light .theme-green-border {
  border-color: #4caf50 !important;
}

.theme--light.theme-background, .theme--light .theme-background, .theme--light.v-navigation-drawer {
  background-color: #ffffff !important;
}

.theme--light.theme-invbackground, .theme--light .theme-invbackground {
  background-color: #000000 !important;
}

.theme--light.theme-back, .theme--light .theme-back {
  background-color: #f9f9f9 !important;
}

.theme--light.theme-highlight, .theme--light .theme-highlight {
  background-color: #ffffff !important;
}

.theme--light.theme-text, .theme--light .theme-text {
  color: #757575 !important;
}

.theme--light.theme-title, .theme--light .theme-title {
  color: #000000 !important;
}

.theme--light.theme-invtitle, .theme--light .theme-invtitle {
  color: #ffffff !important;
}

.theme--light.theme-border, .theme--light .theme-border {
  border-color: #ececec !important;
}

.theme--light.theme-highborder, .theme--light .theme-highborder {
  border-color: #dddddd !important;
}

.theme--light.theme-hightext, .theme--light .theme-hightext {
  color: #aaaaaa !important;
}

.theme--light.theme-excluded, .theme--light .theme-excluded {
  background-color: #bdbdbd !important;
}

.theme--light.theme-selected, .theme--light .theme-selected {
  background-color: #d3e4d3 !important;
}

.theme--dark.theme-default, .theme--dark .theme-default {
  background-color: #1e1e1e !important;
}

.theme--dark.theme-red-background, .theme--dark .theme-red-background {
  background-color: #F73051 !important;
}

.theme--dark.theme-green-background, .theme--dark .theme-green-background {
  background-color: #4caf50 !important;
}

.theme--dark.theme-red, .theme--dark .theme-red {
  color: #F73051 !important;
}

.theme--dark.theme-green, .theme--dark .theme-green {
  color: #4caf50 !important;
}

.theme--dark.theme-border-inverse, .theme--dark .theme-border-inverse {
  border-color: #ffffff !important;
}

.theme--dark.theme-red-border, .theme--dark .theme-red-border {
  border-color: #F73051 !important;
}

.theme--dark.theme-green-border, .theme--dark .theme-green-border {
  border-color: #4caf50 !important;
}

.theme--dark.theme-background, .theme--dark .theme-background, .theme--dark.v-navigation-drawer {
  background-color: #262830 !important;
}

.theme--dark.theme-invbackground, .theme--dark .theme-invbackground {
  background-color: #ffffff !important;
}

.theme--dark.theme-back, .theme--dark .theme-back {
  background-color: #1e2028 !important;
}

.theme--dark.theme-highlight, .theme--dark .theme-highlight {
  background-color: #40434f !important;
}

.theme--dark.theme-text, .theme--dark .theme-text {
  color: #9298af !important;
}

.theme--dark.theme-title, .theme--dark .theme-title {
  color: #ffffff !important;
}

.theme--dark.theme-invtitle, .theme--dark .theme-invtitle {
  color: #1e1e1e !important;
}

.theme--dark.theme-border, .theme--dark .theme-border {
  border-color: #2d303e !important;
}

.theme--dark.theme-highborder, .theme--dark .theme-highborder {
  border-color: #4d5269 !important;
}

.theme--dark.theme-hightext, .theme--dark .theme-hightext {
  color: #4d5269 !important;
}

.theme--dark.theme-excluded, .theme--dark .theme-excluded {
  background-color: #4d5269 !important;
}

.theme--dark.theme-selected, .theme--dark .theme-selected {
  background-color: #40434f !important;
}

.theme-transparent {
  background-color: transparent !important;
}

.action-button-group {
  width: 100%;
  height: 100%;
}

.v-application .v-list-item--disabled.primary--text {
  color: #5687FF !important;
}

[disabled="disabled"] {
  pointer-events: none !important;
}
</style>
